<template>
  <div class="row">
    <div class="col">
      <p>As reference, the following are Wasabi account parameters.</p>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-2">
      <span class="custom-label">Number:</span>
    </div>
    <div class="col">
      <div class="row">
        <div class="col">
          {{ wasabiAccount?.acctNum }}
        </div>
        <div class="col-2 custom-id" title="LaunchPad Firm Id">
          {{ wasabiAccount?.firm }}
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-2">
      <span class="custom-label">Name:</span>
    </div>
    <div class="col">
      {{ wasabiAccount?.acctName }}
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-2">
      <span class="custom-label">Created On:</span>
    </div>
    <div class="col">
      {{ formatDate(wasabiAccount?.createTime) }}
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-2">
      <span class="custom-label">Partner:</span>
    </div>
    <div class="col">
      {{ formatSource(wasabiAccount?.source) }}
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { locationStore } from '@/stores/location'
import globals from '@/plugins/globals'
export default {
  name: 'LocationWasabi',
  data() {
    return {
      // Your data properties go here
    }
  },
  computed: {
    ...mapState(locationStore, ['wasabiAccount'])
    // Your computed properties go here
  },
  methods: {
    formatDate(date, type = 'datetime') {
      return globals.formatDate(date, type)
    },
    formatSource(data) {
      let source = null
      if (data) {
        if (data === 'Calibrate' || data === 'TestDrive') {
          source = `Legacy - ${data}`
        } else {
          source = data
        }
      }
      return source
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-label {
  font-weight: 500;
}
</style>
